import React from 'react'
import { Modal } from 'antd';
import Character from './Character';


export default function CharacterModal({
    isModalVisible, 
    setIsModalVisible, 
    refresh,
    characterTypes,
    characterStatusses,
    races,
    originalCharacter
}){

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    return (
            <Modal 
                title={`Character (${originalCharacter?.name})`}  
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                footer={null}
                width={"80%"}
                
            >
                <Character 
                    refresh={refresh}
                    characterTypes={characterTypes}
                    characterStatusses={characterStatusses}
                    races={races}
                    originalCharacter={originalCharacter}
                />
            </Modal>
    )
}